import { I18nComponente } from "@/types/gerais"

export const ODetalhesEventoi18n: I18nComponente = {
  "pt-BR": {
    problemas: {
      "0000": {
        problema: "Atividade mais longa do que o esperado"
      },
      "0001": {
        problema: "Atividade mais curta que o esperado"
      },
      "0002": {
        problema: "Atividade realizada sem planejamento"
      }
    },
    inicio: "início",
    fim: "fim",
    editar: "editar",
    excluir: "excluir",
    voltar: "voltar",
    correcaoManual: "(correção manual)",
    autocompletar: "(autocompletado)",
    peloAppTimesheet: "(registrado pelo app Timesheet)",
    peloAppGestao: "(registrado pelo app Pontotel Gestão)",
    peloBrowser: "(registrado pelo navegador)",
    naoPossivelFazerAlteracoesNestaAtividade: "não é possível fazer alterações nesta atividade",
    atividadeTravada: "atividade travada"
  },
  "es-CO": {
    problemas: {
      "0000": {
        problema: "Actividad más larga de lo esperado"
      },
      "0001": {
        problema: "Actividad más corta de lo esperado"
      },
      "0002": {
        problema: "Actividad realizada sin planificación"
      }
    },
    inicio: "inicio",
    fim: "fin",
    editar: "editar",
    excluir: "borrar",
    voltar: "volver",
    correcaoManual: "(ingreso manual)",
    autocompletar: "(autocompletado)",
    peloAppTimesheet: "(registrado por la aplicación Timesheet)",
    peloAppGestao: "(registrado por la aplicación Pontotel Gestão)",
    peloBrowser: "(registrado por navegador)",
    naoPossivelFazerAlteracoesNestaAtividade: "no es posible hacer cambios en esta actividad",
    atividadeTravada: "actividad congelada"
  }
}
